import React from 'react'
import './Loader.css'
function Loader() {
    return <div className="lds-circle"><div></div></div>
}

export default Loader
